export const profileEmailSectionStyles = {
  shell: 'flex min-h-12 items-center gap-2 overflow-hidden rounded-[10px] bg-background',
  input:
    'h-12 min-w-0 flex-1 border-0 bg-transparent px-4 text-sm text-[#7d8087] outline-none disabled:cursor-not-allowed',
  fieldLabel: 'text-[13px] text-[#565961]',
  fieldInput:
    'h-12 rounded-[10px] border border-[#dadde4] bg-white px-3.5 text-sm text-[#1b1d22] outline-none',
  link: 'shrink-0 text-sm font-medium text-[#505CFF] hover:text-blue-300 disabled:cursor-not-allowed disabled:text-[#9699a1] disabled:hover:text-[#9699a1]',
  shellLink: 'shrink-0 pr-3 text-sm font-medium text-[#505CFF] hover:text-blue-300',
  primary:
    'inline-flex min-h-[42px] items-center justify-center rounded-[10px] bg-[#A9F84A] px-4 text-sm font-bold text-[#1b1d22] hover:bg-[#8EE328] disabled:opacity-50',
  secondary:
    'inline-flex min-h-[42px] items-center justify-center rounded-[10px] bg-[#eceef3] px-4 text-sm font-bold text-[#34373e] hover:bg-[#e2e4ea] disabled:opacity-50',
  helper: 'mt-2 text-[13px] leading-relaxed text-[#6d7078]',
  error: 'mt-1 text-xs text-red-500',
  formPanel: 'flex flex-col gap-2.5 rounded-[11px] bg-background p-3.5',
  codeInput:
    'sm:h-12 min-w-0 flex-1 rounded-[10px] border border-[#dadde4] bg-white px-3.5 text-lg tracking-[0.18em] text-[#1b1d22] outline-none',
};
